module.exports = __webpack_public_path__ + "img/1.b08df7f0.jpg";